<script>
import Layout from '../../layout/Layout'
import Menu from '../menu'
import MenuOptions from '../../layout/context-menu/context-window-options'
import DefaultMixin from '../mixin'

export default {
  name: 'TasskPage',
  mixins: [DefaultMixin],
  components: {
    Layout
  },
  data () {
    return {
    }
  },
  computed: {
    menu () {
      return Menu
    },
    menuDashOptions () {
      return MenuOptions
    }
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {
  },
  meta: {
    title: 'Tarefas',
    name: 'Tarefas'
  }
}
</script>

<template>
  <layout class="erp-list" :menu="menu" menu-style="compact" menu-active="tasks" no-title>
    <router-view />
  </layout>
</template>

<style lang="stylus" src="../assets/default.styl"></style>
